"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.adminSubscriptionContract = void 0;
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const models_1 = require("../draw/draw/models");
const models_2 = require("../draw/drawOrder/models");
const models_3 = require("../order/models");
const utils_1 = require("../utils");
const models_4 = require("./models");
const c = (0, core_1.initContract)();
exports.adminSubscriptionContract = c.router({
    getSubscriptionsForPlayer: {
        method: 'GET',
        path: '/player/:player_id',
        pathParams: zod_1.z.object({
            player_id: zod_1.z.string(),
        }),
        responses: {
            200: zod_1.z.array(zod_1.z.object({
                order: models_3.ZOrderSelect,
                drawOrder: models_2.ZDrawOrderSelect,
                subscription: models_4.ZSubscriptionSelect,
                drawSchedulePlans: zod_1.z
                    .object({
                    drawSchedule: models_1.ZDrawScheduleSelect,
                    drawTypePlan: models_1.ZDrawTypePlanSelect,
                })
                    .array(),
                subscriptionRun: zod_1.z.nullable(models_4.ZSubscriptionRunSelect),
                runDrawOrder: zod_1.z.nullable(models_2.ZDrawOrderSelect),
                lastPurchasedDrawId: zod_1.z.number().nullable(),
            })),
        },
    },
    getSubscriptionChanges: {
        method: 'GET',
        path: '/:subscription_id/changes',
        pathParams: zod_1.z.object({
            subscription_id: zod_1.z.string(),
        }),
        responses: {
            200: zod_1.z.array(models_4.ZSubscriptionHistorySelect),
        },
    },
    processSubscriptionForPlayer: {
        method: 'POST',
        path: '/:subscription_id/process',
        pathParams: zod_1.z.object({
            subscription_id: zod_1.z.string(),
        }),
        body: zod_1.z.object({}),
        responses: {
            200: zod_1.z.object({
                success: zod_1.z.boolean(),
                message: zod_1.z.string().optional(),
            }),
            400: c.type(),
        },
    },
    cancelSubscriptionForPlayer: {
        method: 'POST',
        path: '/:subscription_id/cancel',
        pathParams: zod_1.z.object({
            subscription_id: zod_1.z.string(),
        }),
        body: zod_1.z.object({}),
        responses: {
            200: utils_1.successSchema,
            400: c.type(),
        },
    },
}, {
    pathPrefix: '/admin',
    strictStatusCodes: true,
    commonResponses: {
        401: c.type(),
        403: c.type(),
    },
});
//# sourceMappingURL=subscription.admin.contract.js.map